






































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';

@Component
export default class FeatureBody extends Vue {
  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly data!: object;

  @Prop() readonly startCount!: number;

  @Prop() readonly handleSub!: Function;

  @Prop() readonly setFeatureMascot!: Function;

  @Prop() readonly changeStatusMascot!: Function;
}
